<template>
    <div id="RegistForm" class="base">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>
            <div style="font-size: 24px; color: whitesmoke">申込みフォーム </div>
        </div>
        <div v-if="currentPage == registPage.Loading" class="regist-area">
        </div>
        <div v-else-if="currentPage == registPage.QueryError" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">URLエラー</div>
                    <div style="color: whitesmoke">
                        指定されたページはURLが間違っているか、有効期限が切れています。
                    </div>
                </div>
            </div>
        </div>
        <!--#68対応_20250418
        <div v-else-if="currentPage == registPage.Login" class="auth-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ID</div>
                    <input type="text" v-model="id"/>
                    <div style="font-size: 20px; color: whitesmoke">パスワード</div>
                    <input type="password" v-model="password"/>
                    <div v-show="authFaild" class="authFaild">IDまたはパスワードが違います</div>
                </div>
            </div>
            <b-button class="opbutton" icon-left="chevron-double-right" @click="auth">ログイン</b-button>
        </div>
        -->
        <div v-else-if="currentPage == registPage.InputUserInfo" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ユーザー情報を入力してください。</div>
                    <table>
                        <tr><th>メールアドレス</th><td><input type="text" v-model="data.mail" id="mail" name="メールアドレス" validate="required|mail" disabled/></td></tr>
                        <tr><th>ユーザー名<span class="require" /></th>
                        <td><input type="text" class="nameInput" v-model="data.lastName" id="lastName" name="ユーザー名(姓)" validate="required" maxlength="50" placeholder="姓"/>
                            <input type="text" class="nameInput" v-model="data.firstName" id="firstName" name="ユーザー名(名)" validate="required" maxlength="50" placeholder="名"/>
                        </td>
                        </tr>
                        <tr><th>ユーザー名（カナ）<span class="require" /></th>
                        <td><input type="text" class="nameInput" v-model="data.lastNameKana" id="lastNameKana" name="ユーザー名(姓カナ)" validate="required|kana" maxlength="50" placeholder="セイ"/>
                            <input type="text" class="nameInput" v-model="data.firstNameKana" id="firstNameKana" name="ユーザー名(名カナ)" validate="required|kana" maxlength="50" placeholder="メイ"/>
                        </td>
                        </tr>
                        <tr/>
                        <tr><th>パスフレーズ認証</th><td><b-checkbox class="cstmCheckBox" v-model="data.passphraseFlag" id="passphraseFlag">二段階認証を行う</b-checkbox></td></tr>
                        <template v-if="data.passphraseFlag">
                        <tr>
                            <th>　送信先(携帯番号)</th>
                            <td><input type="text" class="passInput" v-model="data.passphraseSendNo" id="passphraseSendNo" name="送信先(携帯番号)" validate="numeric" maxlength="20" placeholder="ハイフン(-)なし。例)09012345678"/><b-button class="passButton" @click="sendTestSMS" :disabled="!isActive">テスト送信</b-button></td>
                        </tr>
                        <tr>
                            <th>　送信先(Eメールアドレス)</th>
                            <td><input type="text" class="passInput" v-model="data.passphraseSendMail" id="passphraseSendMail" name="送信先(Eメールアドレス)" validate="mail" maxlength="256" placeholder="例) example@example.co.jp"/><b-button class="passButton" @click="sendTestMail" :disabled="!isActive">テスト送信</b-button></td>
                        </tr>
                        </template>
                    </table>
                </div>
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">組織情報を入力してください。</div>
                    <table>
                        <tr><th>
                            <span>{{getMedicalInstitutionName()}}</span>
                            <span class="require" />
                        </th><td><input type="text" v-model="data.medicalInstitutionName" id="medicalInstitutionName" :name="getMedicalInstitutionName()" validate="required" maxlength="100"></td></tr>
                        <tr v-if="roleId!=role.role_analysis"><th>
                            　　<span v-if="roleId==role.role_hospital || roleId==role.role_judgment || roleId==role.role_holter_judgment">診療科名<span class="require" /></span>
                            　　<span v-if="roleId==role.role_corporation || roleId==role.role_dealer || roleId==role.role_accommodations">拠点名・部署名<span class="require" /></span>
                            </th>
                            <td>
                                <input v-if="roleId==role.role_hospital || roleId==role.role_judgment || roleId==role.role_holter_judgment" type="text" v-model="data.departmentName" id="departmentName" name="診療科名" validate="required" maxlength="100">
                                <input v-if="roleId==role.role_corporation || roleId==role.role_dealer || roleId==role.role_accommodations" type="text" v-model="data.departmentName" id="departmentName" name="拠点名・部署名" validate="required" maxlength="100">
                            </td>
                        </tr>
                        <tr>
                            <th>郵便番号<span class="require" /></th>
                            <td>
                                <input
                                    type="text"
                                    class="passInput"
                                    :class="{'border-red': invalidPostcode}"
                                    v-model="data.postcode"
                                    id="postcode"
                                    name="郵便番号"
                                    validate="required|numeric|zip"
                                    maxlength="7"
                                    :placeholder="postcodePlaceholder"
                                    @blur="onZipBlur(data.postcode, 'digitErrorPostcode')"
                                />
                                <b-button class="passButton" @click="postCodeSearch" :disabled="!isActive">自動入力</b-button>
                                <div v-show="invalidPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                                <div v-show="digitErrorPostcode" class="text-red">{{ digitErrorZipMessage }}</div>
                            </td>
                        </tr>
                        <tr><th>都道府県<span class="require" /></th>
                            <td>
                                <select v-model="data.prefecture" id="prefecture" name="都道府県" validate="required">
                                    <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                                </select>
                            </td>
                        </tr>
                        <tr><th>市町村区<span class="require" /></th><td><input type="text" v-model="data.city" id="city" name="市町村区" validate="required" maxlength="20"/></td></tr>
                        <tr><th>住所（それ以降の住所）<span class="require"/></th><td><input type="text" v-model="data.address" id="address" name="住所（それ以降の住所）" validate="required" maxlength="100" ref="address1"/></td></tr>
                        <tr><th>住所（建物名、部屋番号）</th><td><input type="text" v-model="data.building" id="building" maxlength="100"/></td></tr>
                        <tr>
                            <th>連絡先<span class="require" /></th>
                            <td>
                                <input
                                    type="text"
                                    :class="{'border-red': invalidPhoneNumber}"
                                    v-model="data.phoneNumber"
                                    id="phoneNumber"
                                    name="連絡先"
                                    validate="required|numeric"
                                    maxlength="11"
                                    :placeholder="phonePlaceholder"
                                />
                                <div v-show="invalidPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                            </td>
                        </tr>
                        <template v-if="roleId==role.role_hospital">
                            <tr>
                                <th></th>
                                <td>
                                    <b-checkbox class="cstmHeaderCheckBox" v-model="data.agreedInfoDisclosure">転院紹介機能を利用し、住所・連絡先を公開する</b-checkbox>
                                </td>
                            </tr>
                            <template v-if="data.agreedInfoDisclosure">
                                <tr>
                                    <th>公開用メールアドレス<span class="require" /></th>
                                    <td>
                                        <input type="text" class="passInput" v-model="data.publicMail" id="publicMail" name="公開用メールアドレス" validate="required|mail" maxlength="256"/><b-button class="passButton" @click="sendTestPublicMail">テスト送信</b-button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>公開用メールアドレス(確認)<span class="require" /></th>
                                    <td>
                                        <input type="text" v-model="publicMailComfirm" id="publicMailComfirm" name="公開用メールアドレス（確認）" validate="required" maxlength="256"/>
                                    </td>
                                </tr>
                            </template>
                        </template>
                        <tr v-if="roleId!=role.role_judgment && roleId!=role.role_analysis && roleId!=role.role_holter_judgment"><th>Philips担当支店<span class="require"/></th>
                            <td>
                                <select v-model="data.branchOfficeCode" id="branchOfficeCode" name="Philips担当支店" validate="required" >
                                    <option value="" style="display:none;">Philipsの担当支店を選択してください</option>
                                    <option v-for="brunch in brunchList" :key="brunch.branchOfficeCode" :value="brunch.branchOfficeCode">
                                        {{brunch.branchOfficeName}}
                                    </option>
                                </select>
                            </td>
                        </tr>
                    </table>
                </div>
                <template v-if="roleId==role.role_hospital || roleId==role.role_dealer">
                    <div class="card-content">
                        <div style="font-size: 20px; color: whitesmoke">利用するサービスを選択してください。<br>
                            <span style="font-size: 15px;">(※複数選択可)</span>
                        </div>
                        <table>
                            <tr>
                                <th>利用するサービス</th>
                                <td>
                                    <ul>
                                        <li><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.hst"                                >睡眠検査機器配送ｻｰﾋﾞｽ（解析結果付）</b-checkbox></li>
                                        <li><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.psg"                                >PSG解析</b-checkbox></li>
                                        <li><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.kenshin"                            >企業検診</b-checkbox></li>
                                        <li><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.holter"                             >ホルター心電図配送ｻｰﾋﾞｽ</b-checkbox></li>
<!-- TODO: 202209対象外                                       
                                        <li><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.holter_analysis"                    >ホルター心電図解析</b-checkbox></li>
-->
                                        <li><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.cpap"                               >CPAP指示書登録サービス</b-checkbox></li>
                                        <li v-if="roleId==role.role_hospital"><b-checkbox class="cstmCheckBox svCheckBox" v-model="serviceCheckBox" :native-value="service.inspection_report">呼吸点検報告書</b-checkbox></li>
                                        <li v-if="roleId==role.role_hospital"><b-checkbox class="cstmCheckBox svCheckBox" v-model="usePDashboard" :disabled="isPDashboardDisabled">{{pDashboardServiceName}}</b-checkbox><br><span style="font-size:12px;">※ケア　オーケストレーターをご利用にならない場合は本サービスをご使用できません。</span></li>
                                    </ul>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="card-content">
                        <div style="font-size: 16px; color: whitesmoke">ケア　オーケストレーター利用状況</div>
                        <table>
                            <tr>
                                <th>ケア　オーケストレーター</th>
                                <td><div>
                                    <b-radio class="td_radio sv_radio" name="coInUse"  v-model="data.coInUse"  @input="uncheckPDashboard(false)" :native-value="coUse_db.notUse" >はじめて利用する</b-radio>
                                    <b-radio class="td_radio sv_radio" name="coInUse"  v-model="data.coInUse"  @input="uncheckPDashboard(false)" :native-value="coUse_db.inUse" >既に利用中</b-radio>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th></th>
                                <td><div>
                                    <b-radio class="td_radio sv_radio" name="coInUse"  v-model="data.coInUse" @input="uncheckPDashboard(true)" :native-value="coUse_db.afterUse" >今は利用しない</b-radio>
                                    </div>
                                </td>
                            </tr>
                            <template v-if="data.coInUse==coUse_db.inUse">
                                <tr>
                                    <th><span>メールアドレス</span><span class="require"/></th>
                                    <td>
                                        <input type="text" class="passInput" v-model="data.coMailAddress" id="coMailAddress" name="メールアドレス(ケア オーケストレーター)" maxlength="256" validate="required|mail"/><b-button class="passButton" @click="sendTestCoMailAddress">テスト送信</b-button>
                                    </td>
                                </tr>
                                <tr>
                                    <th>メールアドレス(確認)<span class="require" /></th>
                                    <td>
                                        <input type="text" v-model="coMailAddressComfirm" id="coMailAddressComfirm" name="メールアドレス(確認)(ケア オーケストレーター)" validate="required" maxlength="256"/>
                                    </td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td style="font-size:1em;">
                                        <span>※ケア　オーケストレーターを「既に利用中」の場合、Philips側でケア　オーケストレーターのユーザ情報を登録します。登録完了後、電子メールでお知らせします。</span>
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </template>
            </div>
            <b-button class="opbutton" icon-left="offer" @click="registChk" :disabled="!isActive">申込み</b-button>
        </div>
        <!-- ＣＯ同時申込対応 -->
        <div v-else-if="currentPage == registPage.ComfirmCORegist" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 18px; color: whitesmoke; margin:20px 0;">
                        続けてケア　オーケストレーターの利用申請を行いますか？
                    </div>
                    <b-button class="confirmCoButton" @click="currentPage = registPage.CoAgreement">ケア　オーケストレーターの利用申請を行う</b-button>
                    <b-button class="confirmCoButton" @click="doRegistrationConfirm()">今は行わず、登録を完了する</b-button>
                </div>
            </div>
        </div>
        <div v-else-if="currentPage == registPage.CoAgreement" class="regist-area">
            <div id="item-contens">
                <div class="card-content ">
                    <div>
                        <span style="font-size:20px; color:whitesmoke;">ケア　オーケストレーター 利用規約</span>
                        <a @click="download"><b-icon style="margin-top:3px; color:whitesmoke;" icon="file-download-outline"/></a>
                    </div>                    
                    <table>
                        <tr><td><textarea readonly class="cautionArea noresize" v-model="coAgreement" /></td></tr>
                        <tr><td><div  style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isCoAgree" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td>
                        </tr>
                    </table>
                </div>
            </div>
            <b-button class="opbutton" @click="currentPage = registPage.ComfirmCORegist">戻る</b-button>
            <b-button class="opbutton" @click="goCoSetting" :disabled="!isCoAgree">申込みを行う</b-button>
        </div>
        <div v-else-if="currentPage == registPage.InputCOclinicInfo" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ケア　オーケストレーター 施設情報</div>
                    <table>
                        <tr>
                            <th><span>医療機関名</span><span class="require" /></th>
                            <td><input type="text" v-model="data.coMedicalInstitutionName" id="coMedicalInstitutionName" name="医療機関名" validate="required" maxlength="100"></td>
                        </tr>
                        <tr>
                            <th><span>診療科名<span class="require" /></span></th>
                            <td><input type="text" v-model="data.coDepartmentName" id="coDepartmentName" name="診療科名" validate="required" maxlength="100"></td>
                        </tr>
                        <tr>
                            <th>郵便番号<span class="require" /></th>
                            <td>
                                <input
                                type="text"
                                class="passInput"
                                :class="{'border-red': invalidCareOrchestratorPostcode}"
                                v-model="data.coPostcode"
                                id="coPostcode"
                                name="郵便番号"
                                validate="required|numeric"
                                maxlength="7"
                                :placeholder="postcodePlaceholder"
                                />
                                <div v-show="invalidCareOrchestratorPostcode" class="text-red">{{ invalidNumberMessage }}</div>
                            </td>
                        </tr>
                        <tr>
                            <th>都道府県<span class="require" /></th>
                            <td>
                                <select v-model="data.coPrefecture" id="coPrefecture" name="都道府県" validate="required">
                                    <option value=""/><option value="北海道">北海道</option><option value="青森県">青森県</option><option value="岩手県">岩手県</option><option value="宮城県">宮城県</option><option value="秋田県">秋田県</option><option value="山形県">山形県</option><option value="福島県">福島県</option><option value="茨城県">茨城県</option><option value="栃木県">栃木県</option><option value="群馬県">群馬県</option><option value="埼玉県">埼玉県</option><option value="千葉県">千葉県</option><option value="東京都">東京都</option><option value="神奈川県">神奈川県</option><option value="新潟県">新潟県</option><option value="富山県">富山県</option><option value="石川県">石川県</option><option value="福井県">福井県</option><option value="山梨県">山梨県</option><option value="長野県">長野県</option><option value="岐阜県">岐阜県</option><option value="静岡県">静岡県</option><option value="愛知県">愛知県</option><option value="三重県">三重県</option><option value="滋賀県">滋賀県</option><option value="京都府">京都府</option><option value="大阪府">大阪府</option><option value="兵庫県">兵庫県</option><option value="奈良県">奈良県</option><option value="和歌山県">和歌山県</option><option value="鳥取県">鳥取県</option><option value="島根県">島根県</option><option value="岡山県">岡山県</option><option value="広島県">広島県</option><option value="山口県">山口県</option><option value="徳島県">徳島県</option><option value="香川県">香川県</option><option value="愛媛県">愛媛県</option><option value="高知県">高知県</option><option value="福岡県">福岡県</option><option value="佐賀県">佐賀県</option><option value="長崎県">長崎県</option><option value="熊本県">熊本県</option><option value="大分県">大分県</option><option value="宮崎県">宮崎県</option><option value="鹿児島県">鹿児島県</option><option value="沖縄県">沖縄県</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>市町村区<span class="require" /></th>
                            <td><input type="text" v-model="data.coCity" id="coCity" name="市町村区" validate="required" maxlength="20"/></td>
                        </tr>
                        <tr>
                            <th>住所（それ以降の住所）<span class="require"/></th>
                            <td><input type="text" v-model="data.coAddress" id="coAddress" name="住所（それ以降の住所）" validate="required" maxlength="100"/></td>
                        </tr>
                        <tr>
                            <th>住所（建物名、部屋番号）</th>
                            <td><input type="text" v-model="data.coBuilding" id="coBuilding" maxlength="100"/></td>
                        </tr>
                        <tr>
                            <th>連絡先<span class="require" /></th>
                            <td>
                                <input
                                    type="text"
                                    :class="{'border-red': invalidCareOrchestratorPhoneNumber}"
                                    v-model="data.coPhoneNumber"
                                    id="coPhoneNumber"
                                    name="連絡先"
                                    validate="required|numeric"
                                    maxlength="11"
                                    :placeholder="phonePlaceholder"
                                />
                                <div v-show="invalidCareOrchestratorPhoneNumber" class="text-red">{{ invalidNumberMessage }}</div>
                            </td>
                        </tr>
                        <tr>
                            <th>クライアント認証<span class="require" /></th>
                            <td>
                                <div>
                                    <b-radio class="td_radio sv_radio" name="clientAuth" v-model="data.clientAuth" :native-value="true">有効にする</b-radio>
                                    <b-radio class="td_radio sv_radio" name="clientAuth" v-model="data.clientAuth" :native-value="false">有効にしない</b-radio>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <td style="font-size:1em;">
                                <span style="background:red;padding-top:2px;padding-bottom:2px;">※医療情報システムの安全管理に関するガイドライン（厚生労働省）では、医療機関等に向けて「不特定の端末から接続されるリスクがある場合、TLS クライアント認証を行うこと」が求められています。</span>
                                <br/>
                                <span>※クライアント認証機能を有効にした場合、Philipsが発行する証明書をインストールした端末からのみCOにアクセスできます。</span>
                            </td>
                        </tr>
                        <tr>
                            <th>備考</th>
                            <td>
                                <textarea v-model="data.coBiko" maxlength="256" style="resize:none;max-width:100%;"/>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="card-content">
                    <table>
                        <tr>
                            <th>■情報の管理に関する事項</th>
                        </tr>
                        <tr>
                            <td style="padding-left:10px;font-size:1em;"><span>申請者は、上記の情報がケア　オーケストレーター上で管理されることに同意します。<br>
                                株式会社フィリップス・ジャパンは、当申請書より知り得た情報を、ケア　オーケストレーターに関わる運用保守業務以外に使用しません。</span>
                            </td>
                        </tr>
                    </table>
                </div>
                <b-button class="opbutton" @click="currentPage = registPage.CoAgreement">戻る</b-button>
                <b-button class="opbutton" @click="coClinicChk">進む</b-button>
            </div>
        </div>
        <div v-else-if="currentPage == registPage.InputCOuserInfo" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ケア　オーケストレーター ユーザー情報</div>
                    <template v-for="(coUser, index) in coUserList">
                        <div class="card-content" :key="index">
                            <table>
                                <tr v-if="index > 0">
                                    <td colspan="2">
                                    <b-button
                                        style="float:right; width:27px; height:27px; border:none;color: white;background:none;"
                                        icon-left="close-box-outline"
                                        @click="deleteCoUser(index)"></b-button>
                                    </td>
                                </tr>
                                <tr><th>ユーザー名<span class="require" /></th>
                                    <td>
                                        <input type="text" v-model="coUser.familyName" maxlength="100" class="coUserChk coNameInput" :name="index+1+'番目ユーザー姓'" validate="required" :id="index+'familyName'" placeholder="姓"/>
                                        <input type="text" v-model="coUser.firstName" maxlength="100" class="coUserChk coNameInput" :name="index+1+'番目ユーザー名'" validate="required"  :id="index+'firstName'" placeholder="名"/>
                                    </td>
                                </tr>
                                <tr>
                                    <th>処方設定<span class="require" /></th><td>
                                    <div class="block">
                                        <b-radio class="td_radio sv_radio" :name="'prescription' + index" v-model="coUser.prescriptionSettings" :native-value="true">操作可</b-radio>
                                        <b-radio class="td_radio sv_radio" :name="'prescription' + index" v-model="coUser.prescriptionSettings" :native-value="false">操作不可</b-radio>
                                    </div></td>
                                </tr>
                                <tr>
                                    <th>ユーザーID(第一希望)<span class="require" /></th>
                                    <td><input type="text" class="coUserChk" v-model="coUser.userIDFirstChoice" maxlength="20" placeholder="英数記号('-','_')のうち2種類を含む6~20文字" :name="index+1+'番目ユーザーID:第一希望'" validate="required|userId" :id="index+'userId1'"/></td></tr>
                                <tr>
                                    <th>ユーザーID(第二希望)<span class="require" /></th>
                                    <td><input type="text" class="coUserChk" v-model="coUser.userIDSecondChoice" maxlength="20" placeholder="英数記号('-','_')のうち2種類を含む6~20文字" :name="index+1+'番目ユーザーID:第二希望'" validate="required|userId" :id="index+'userId2'"/></td></tr>
                                <tr>
                                    <th>ユーザーID(第三希望)<span class="require" /></th>
                                    <td><input type="text" class="coUserChk" v-model="coUser.userIDThirdChoice" maxlength="20" placeholder="英数記号('-','_')のうち2種類を含む6~20文字" :name="index+1+'番目ユーザーID:第三希望'" validate="required|userId" :id="index+'userId3'"/></td>
                                </tr>
                                <tr>
                                    <th>メールアドレス<span class="require" /></th>
                                    <td><input type="text" v-model="coUser.mail" class="coUserChk" :name="index+1+'番目ユーザーメールアドレス'" validate="required|mail"  :id="index+'comail'" maxlength="256"/></td>
                                </tr>
                                <tr><th></th><td style="font-size:1em;">※ID登録完了、パスワードの再発行等はご登録いただいたメールアドレス宛てに、電子メールにてお知らせします。</td></tr>
                                <!-- Phase2 ケアオケ issue#20-->
                                <tr>
                                    <th>ケア　エクスポーター<span class="require"/></th>
                                    <td>
                                        <div class="block">
                                        <b-radio class="td_radio sv_radio" :name="'careExporter' + index" v-model="coUser.careExporter" :native-value="true">利用する</b-radio>
                                        <b-radio class="td_radio sv_radio" :name="'careExporter' + index" v-model="coUser.careExporter" :native-value="false">利用しない</b-radio>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th />
                                    <td style="font-size:1em;">
                                    <span class="information_text">
                                        ※治療レポートや患者一覧を一括出力することができるオプションツールです。詳細は担当営業にご確認ください。関連資料は<a class="under_line" :href="getUrlCatalog()" target="_blank" rel="noopener noreferrer">こちら</a>
                                    </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </template>
                    <div style="margin-top:10px;margin-bottom:10px; text-align: left;">
                        <b-button  icon-left="account-multiple-plus" style="width:40%;" @click="addCoUser" >別のユーザーを追加する</b-button>
                    </div>
                    <div class="card-content">
                        <table>
                            <tr><th>■個人情報の管理に関する事項</th></tr>
                            <tr><td style="padding-left:10px;font-size:1em;">
                                    申請者は、上記の個人情報がケア　オーケストレーター上で管理されることに同意します。<br>
                                    株式会社フィリップス・ジャパンは、当申請書より知り得た個人情報を、ケア　オーケストレーターに関わる運用保守業務以外に使用しません。<br>
                                    ID・パスワード忘れに関するお問い合わせは、お電話での回答はできかねますのでご了承ください。<br>
                                    異動などの事由により当ユーザーアカウントを使用されなくなった場合には、速やかに弊社営業担当者までお知らせ下さい。<br>
                                    また、定期的にユーザーアカウントが使用されているか、確認させていただくことがございます。
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <b-button class="opbutton" @click="currentPage = registPage.InputCOclinicInfo">戻る</b-button>
                <b-button class="opbutton" @click="coUserChk">進む</b-button>
            </div>
        </div>
        <div v-else-if="currentPage == registPage.ComfirmCOInfo" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ケア　オーケストレーター 施設情報</div>
                    <table>
                        <tr>
                            <th>医療機関名</th>
                            <td>{{data.coMedicalInstitutionName}}</td>
                        </tr>
                        <tr>
                            <th>診療科名</th>
                            <td>{{data.coDepartmentName}}</td>
                        </tr>
                        <tr>
                            <th>郵便番号</th>
                            <td>{{data.coPostcode}}</td>
                        </tr>
                        <tr>
                            <th>都道府県</th>
                            <td>{{data.coPrefecture}}</td>
                        </tr>
                        <tr>
                            <th>市町村区</th>
                            <td>{{data.coCity}}</td>
                        </tr>
                        <tr>
                            <th>住所（それ以降の住所）</th>
                            <td>{{data.coAddress}}</td>
                        </tr>
                        <tr>
                            <th>住所（建物名、部屋番号）</th>
                            <td>{{data.coBuilding}}</td>
                        </tr>
                        <tr>
                            <th>連絡先</th>
                            <td>{{data.coPhoneNumber}}</td>
                        </tr>
                        <tr>
                            <th>クライアント認証</th>
                            <td>
                                <div>
                                    <b-radio class="td_radio sv_radio" v-model="data.clientAuth" :native-value="true" disabled>有効にする</b-radio>
                                    <b-radio class="td_radio sv_radio" v-model="data.clientAuth" :native-value="false" disabled>有効にしない</b-radio>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>備考</th>
                            <td>
                                <textarea v-model="data.coBiko" maxlength="256" style="resize:none;max-width:100%;" disabled/>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">ケア　オーケストレーター ユーザー情報</div>
                    <template v-for="(coUser, index) in coUserList">
                        <div class="card-content" :key="index">
                            <table>
                                <tr><th>ユーザー名</th>
                                    <td>{{coUser.familyName}} {{coUser.firstName}}</td>
                                </tr>
                                <tr>
                                    <th>処方設定</th><td>
                                    <div class="block">
                                        <b-radio class="td_radio sv_radio" v-model="coUser.prescriptionSettings" :native-value="true" disabled>操作可</b-radio>
                                        <b-radio class="td_radio sv_radio" v-model="coUser.prescriptionSettings" :native-value="false" disabled>操作不可</b-radio>
                                    </div></td>
                                </tr>
                                <tr>
                                    <th>ユーザーID(第一希望)</th>
                                    <td>{{coUser.userIDFirstChoice}}</td>
                                </tr>
                                <tr>
                                    <th>ユーザーID(第二希望)</th>
                                    <td>{{coUser.userIDSecondChoice}}</td>
                                </tr>
                                <tr>
                                    <th>ユーザーID(第三希望)</th>
                                    <td>{{coUser.userIDThirdChoice}}</td>
                                </tr>
                                <tr>
                                    <th>メールアドレス</th>
                                    <td>{{coUser.mail}}</td>
                                </tr>
                                <tr>
                                    <th>ケア　エクスポーター</th><td>
                                    <div class="block">
                                        <b-radio class="td_radio sv_radio" v-model="coUser.careExporter" :native-value="true" disabled>利用する</b-radio>
                                        <b-radio class="td_radio sv_radio" v-model="coUser.careExporter" :native-value="false" disabled>利用しない</b-radio>
                                    </div></td>
                                </tr>
                            </table>
                        </div>
                    </template>
                </div>
                <b-button class="opbutton" @click="currentPage = registPage.InputCOuserInfo">戻る</b-button>
                <b-button class="opbutton" @click="coRegist" :disabled="!isActive">申込み</b-button>
            </div>
        </div>
        <div v-else class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 18px; color: whitesmoke; margin:20px 0;">
                        登録の申し込みが完了しました。<br>
                    </div>
                    <div style="font-size: 13px; color: whitesmoke; margin:20px 30px;text-align: left;">
                        ※システムへの登録が完了しましたら、登録済みメールアドレスに登録完了メールが送付されます。<br>
                        登録完了メールが届きましたらメール本文に記載されているURLにアクセスし、登録済みメールアドレスおよび初期パスワードを使ってログインしてください。<br>
                        ※初期パスワードは登録完了メールに記載されております。<br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
  service,
  role,
  registPage,
  consentStatement,
  coUse_db,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  digitErrorZipMessage,
  pDashboardServiceName,
} from "@/components/mock/base/const.js";

export default {
  name: "RegistForm",
  data() {
    //pathでどこからの申込みか判断する。
    var path = this.$route.path
    var roleId = 0;
    if(path == "/hregist2"){
        roleId = role.role_hospital
    } else if(path == "/cregist2"){
        roleId = role.role_corporation
    } else if(path == "/dregist2"){
        roleId = role.role_dealer
    } else if(path == "/jregist2"){
        roleId = role.role_judgment
    } else if(path == "/hjregist2"){
        roleId = role.role_holter_judgment
    } else if(path == "/aregist2"){
        roleId = role.role_analysis
    } else if(path == "/acregist2"){
        roleId = role.role_accommodations
    } 
    var query = this.$route.query.key
    var regId = process.env.REGIST_ID
    var regPwd = process.env.REGIST_PWD

    //初期値
    var data = {
        "mail":"",
        "passphraseFlag":false,
        "passphraseSendNo":"",
        "passphraseSendMail":"",
        "agreedInfoDisclosure": false,
        "publicMail": "",
        "serviceId":0,
        "coInUse":null,
        "coMailAddress":"",
    }
    return {
        regId: regId,
        regPwd: regPwd,
        id: "",
        password: "",
        data: data,
        mail:"",
        roleId: roleId,
        query: query,
        authFaild: false,
        service: service,
        serviceCheckBox: [],
        role:role,
        registPage:registPage,
        currentPage: registPage.Loading,
        coUse_db:coUse_db,
        isActive: true,
        brunchList:[],
        token:{},
        publicMailComfirm: "",
        coAgreement:"",
        coMailAddressComfirm: "",
        canAgree:false,
        extUserId: null,
        belongsId: null,
        isCoAgree:false,
        coUserList:[],
        CoCheckBox:[],
        invalidPostcode: false,
        invalidPhoneNumber: false,
        invalidCareOrchestratorPostcode: false,
        invalidCareOrchestratorPhoneNumber: false,
        digitErrorZipMessage,
        digitErrorPostcode:false,
        pDashboardServiceName: pDashboardServiceName,
        usePDashboard: false,
        isPDashboardDisabled: false,
    };
  },
  methods: {
    getMedicalInstitutionName: function(){
        var ret = "医療機関名"
        if(this.roleId==this.role.role_corporation || this.roleId==this.role.role_dealer || this.roleId==this.role.role_accommodations){
            ret = "企業名"
        } else if(this.roleId==this.role.role_analysis){
             ret = "氏名"
        }
        return ret;
    },
    sendTestSMS: function(){
        if(this.data.passphraseSendNo != ""){
            var checkFields = [document.getElementById("passphraseSendNo")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                    passphraseSendMail:"",
                    passphraseSendNo:this.data.passphraseSendNo
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("送信先(携帯番号)を入力してください。")
        }
    },
    sendTestMail: function(){
        if(this.data.passphraseSendMail != ""){
            var checkFields = [document.getElementById("passphraseSendMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                passphraseSendMail:this.data.passphraseSendMail,
                    passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("送信先(Eメールアドレス)を入力してください。")
        }
    },
    sendTestPublicMail: function(){
        if(this.data.publicMail != ""){
            var checkFields = [document.getElementById("publicMail")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                passphraseSendMail:this.data.publicMail,
                    passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("公開用メールアドレスを入力してください。")
        }
    },
    sendTestCoMailAddress: function(){
        if(this.data.coMailAddress != ""){
            var checkFields = [document.getElementById("coMailAddress")];
            var result = this.selfMadeValidation(checkFields)
            if(result.msg == ""){
                this.sendTest({
                passphraseSendMail:this.data.coMailAddress,
                    passphraseSendNo:""
                });
            } else {
                this.showErrorMessage(result.msg)
            }
        } else {
            this.showErrorMessage("メールアドレス(ケア オーケストレーター)を入力してください。")
        }
    },
    sendTest: function(param){
        this.isActive = false;
        try {
            this.$store.dispatch("sendTest", {
              token: this.token,
              contactAddress: param.passphraseSendMail,
              contactPhoneNumber: param.passphraseSendNo
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.showMessage("メッセージを送信しました。<br>指定した宛先にメッセージが届いていることを確認してください。") 
                } else {
                    this.showErrorMessage(result.message) 
                }
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        } finally {
            this.isActive = true;
        }
    },
    postCodeSearch: function(){
        this.isActive = false;
        try {
            this.$store.dispatch("getAddressFromPostCode", {
                token: this.token,
                postCode:this.data.postcode
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.data.prefecture = result.obj.prefecture;
                    this.data.city = result.obj.city;
                    this.data.address = result.obj.town;
                    this.data.building = "";

                    // QA476 住所設定後フォーカスを移動する
                    this.focusMove("address1");
                    this.digitErrorPostcode = false;
                } else if(result != null && result.status === 400 ) {
                    // this.showErrorMessage(result.response.obj.message) // 一致する住所がない場合はなにもしない
                }else {
                    this.showErrorMessage(result.message) 
                }
                this.isActive = true;
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
                this.isActive = true;
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
            this.isActive = true;
        }
    },
    auth: function(event) {
        try {
            this.$store.dispatch("registAuth", {
                id: this.id,
                password: this.password
            }).then(result => {
                console.log(result);
                if(result != null && result.status === 200 ) {
                    this.token = result.obj.token;
                    this.currentPage = this.registPage.InputUserInfo;
                } else {
                    this.currentPage = this.registPage.QueryError;
                }
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        }
    },
    registChk: function() {
        if(this.checkInput()){
            this.regist();
        }
    },
    regist: function() {
        this.isActive = false;
        this.data.useServiceId = 0
        if(this.roleId == this.role.role_corporation || this.roleId == role.role_accommodations){
            //企業と宿泊施設は利用サービスを企業検診に強制
            this.data.useServiceId = this.service.kenshin;
        } else {
            for (var value of Object.values(this.serviceCheckBox)) {
                this.data.useServiceId += value;
            }
        }
        if(!this.data.coInUse){
            //ケアオケ利用状況を設定しない権限の場合は、「今は利用しない」に強制
            this.data.coInUse = this.coUse_db.afterUse;
        }
        var appVue = this.$root.$children[0];
        this.isActive = false;
        appVue.loadingStart();
        this.$store.dispatch("registration", {
            token: this.token,
            authorityCode: this.roleId + "",
            mail: this.data.mail,
            lastName: this.data.lastName,
            firstName: this.data.firstName,
            lastNameKana: this.data.lastNameKana,
            firstNameKana: this.data.firstNameKana,
            phoneNumber: this.data.phoneNumber,
            passPhrase: this.data.passphraseFlag,
            passPhone: this.data.passphraseSendNo,
            passMail: this.data.passphraseSendMail,
            companyName: this.data.medicalInstitutionName,
            division: this.data.departmentName,
            zip: this.data.postcode,
            prefecture: this.data.prefecture,
            city: this.data.city,
            address1: this.data.address,
            address2: this.data.building ? this.data.building: "",
            agreedInfoDisclosure: this.data.agreedInfoDisclosure,
            publicMail: this.data.publicMail,
            branchOfficeCode: this.data.branchOfficeCode,
            serviceId: this.data.useServiceId,
            coInUse:this.data.coInUse,
            coMailAddress:this.data.coMailAddress,
            usePDashboard: this.usePDashboard,
        }).then(result => {
            appVue.loadingEnd();
            this.isActive = true;
            if(result != null && result.status === 200 ) {
                if(this.roleId == this.role.role_hospital && this.data.coInUse == this.coUse_db.notUse){
                    //ＣＯが初めて利用するの場合
                    this.getCoAgreement();
                    this.extUserId = result.obj.extUserId;
                    this.belongsId = result.obj.belongsId;
                    this.currentPage = this.registPage.ComfirmCORegist;
                } else {
                    this.currentPage = this.registPage.FinishRegist;
                }
            } else if (result != null && (result.status === 400 || result.status === 401 || result.status === 500)){
                var message = "予期しないエラーが発生しました。"
                if(result.response.body){
                    message = result.response.body.message
                } else if(result.message){
                    message = result.message
                }
                this.showErrorMessage(message)
            } else {
                this.showErrorMessage("予期しないエラーが発生しました。")
            }
        }).catch(error => {
            appVue.loadingEnd();
            this.isActive = true;
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        });
    },
    checkInput: function(){
        var ret = true;
        var errMsg;

        /** ユーザー情報 */
        var userInfo = [];
        userInfo.push(document.getElementById("mail"));
        userInfo.push(document.getElementById("lastName"));
        userInfo.push(document.getElementById("firstName"));
        userInfo.push(document.getElementById("lastNameKana"));
        userInfo.push(document.getElementById("firstNameKana"));
        if(this.data.passphraseFlag){
            userInfo.push(document.getElementById("passphraseSendNo"));
            userInfo.push(document.getElementById("passphraseSendMail"));
        }
        var userInfoResult = this.selfMadeValidation(userInfo);
        errMsg = userInfoResult.msg;

        // パスフレーズ認証オンの場合
        if(this.data.passphraseFlag){
            var passphraseSendNoElm = document.getElementById("passphraseSendNo");
            var passphraseSendMailElm = document.getElementById("passphraseSendMail");

            // 送信先電話番号かメールアドレスはどちらか必須
            if (passphraseSendNoElm.value == "" && passphraseSendMailElm.value == ""){
                errMsg = errMsg + "送信先(携帯番号)または、送信先(Eメールアドレス)を入力してください。\n"
                passphraseSendNoElm.style["border-color"] = "red";
                passphraseSendMailElm.style["border-color"] = "red";
            }

            // 送信先電話番号、メールアドレスの形式チェック
            var passphraseSendInfo = [];
            passphraseSendInfo.push(passphraseSendNoElm);
            passphraseSendInfo.push(passphraseSendMailElm);
            var passphraseSendInfoResult = this.selfMadeValidation(passphraseSendInfo);
            errMsg = errMsg + passphraseSendInfoResult.msg;
        }

        /** 組織情報 */
        var organizationInfo = [];
        organizationInfo.push(document.getElementById("medicalInstitutionName"));
        if(this.roleId != this.role.role_analysis){
            organizationInfo.push(document.getElementById("departmentName"));
        }
        organizationInfo.push(document.getElementById("postcode"));
        organizationInfo.push(document.getElementById("prefecture"));
        organizationInfo.push(document.getElementById("city"));
        organizationInfo.push(document.getElementById("address"));
        organizationInfo.push(document.getElementById("phoneNumber"));

        var organizationInfoResult = this.selfMadeValidation(organizationInfo);
        errMsg = errMsg + organizationInfoResult.msg;

        // 連絡先を公開する場合
        if(this.data.agreedInfoDisclosure){
            var publicMailElm = document.getElementById("publicMail");
            var publicMailComfirmElm = document.getElementById("publicMailComfirm");

            // 公開用メールアドレス、確認用メールアドレスの形式チェック
            var publicMailInfo = [];
            publicMailInfo.push(publicMailElm);
            publicMailInfo.push(publicMailComfirmElm);
            var publicMailInfoResult = this.selfMadeValidation(publicMailInfo);
            errMsg = errMsg + publicMailInfoResult.msg;

            // 公開用と確認用が一致しているかチェック
            if(this.data.publicMail != this.publicMailComfirm){
                errMsg = errMsg + "公開用メールアドレス(確認)が一致しません。\n"
                publicMailElm.style["border-color"] = "red";
                publicMailComfirmElm.style["border-color"] = "red";
            }
        }

        // 担当支店
        if(this.roleId != this.role.role_judgment && this.roleId != this.role.role_analysis && this.roleId != this.role.role_holter_judgment){
            var branchOffice = [];
            branchOffice.push(document.getElementById("branchOfficeCode"));
            var branchOfficeResult = this.selfMadeValidation(branchOffice);
            errMsg = errMsg + branchOfficeResult.msg;
        }

        /** ケアオーケストレーター利用状況 */
        if(this.roleId == this.role.role_hospital || this.roleId == this.role.role_dealer){
            var coMailAddressElm = document.getElementById("coMailAddress");
            var coMailAddressComfirmElm = document.getElementById("coMailAddressComfirm");
            if(this.data.coInUse == null){
                // 未選択の場合
                errMsg = errMsg + "ケア　オーケストレーター利用状況を選択してください。\n"
            } else if(this.data.coInUse == this.coUse_db.inUse){
                // 既に利用中を選択している場合、メールアドレスの形式チェック
                var coMailAddressInfo = [];
                coMailAddressInfo.push(coMailAddressElm);
                coMailAddressInfo.push(coMailAddressComfirmElm);
                var coMailAddressResult = this.selfMadeValidation(coMailAddressInfo);
                errMsg = errMsg + coMailAddressResult.msg;

                // メールアドレスが確認用と一致しているかチェック
                if(this.data.coMailAddress != this.coMailAddressComfirm){
                    errMsg = errMsg + "メールアドレス(確認)(ケア オーケストレーター)が一致しません。\n"
                    coMailAddressElm.style["border-color"] = "red";
                    coMailAddressComfirmElm.style["border-color"] = "red";
                }
            }
        }

        if(errMsg != ""){
            this.showErrorMessage(errMsg);
            ret = false;
        }
        return ret;
    },
    getBrunchList: function () {
        try {
            this.$store.dispatch("getBrunchList", {
            }).then(result => {
                console.log(result);
                this.brunchList = result.obj;
            }).catch(error => {
                console.log(error);
                this.showErrorMessage("予期しないエラーが発生しました。")
            });
        } catch(err){
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
        }
    },
   getCoAgreement: function(){
       this.$store.dispatch("getConsentStatement", {
           type: consentStatement.registPage,
       }).then(result => {
           console.log(result);
           this.coAgreement ="ケア　オーケストレーター申請の利用規約が登録されていません。"
           if(result != null && result.status === 200 ) {
               if(result.body.contents != ""){
                   this.coAgreement = result.body.contents;
                   this.canAgree = true;
               }
           }
       }).catch(error => {
           console.log(error);
           this.showErrorMessage("予期しないエラーが発生しました。")
       });
   },
   goCoSetting: function(){
       if(!this.data.coMedicalInstitutionName){
           this.data.coMedicalInstitutionName = this.data.medicalInstitutionName;
           this.data.coDepartmentName = this.data.departmentName;
           this.data.coPostcode = this.data.postcode;
           this.data.coPrefecture = this.data.prefecture;
           this.data.coCity = this.data.city;
           this.data.coAddress = this.data.address;
           this.data.coBuilding = this.data.building;
           this.data.coPhoneNumber = this.data.phoneNumber;
           this.data.clientAuth =false;
           this.data.coBiko ="";
           this.coUserList = [{
               familyName: this.data.lastName,
               firstName: this.data.firstName,
               prescriptionSettings: true,  //Phase2ケアオケ issue#25
               userIDFirstChoice:"",
               userIDSecondChoice:"",
               userIDThirdChoice:"",
               careExporter: false,  //Phase2ケアオケ issue#20               
               mail: this.data.mail,
               userClassification:"医療従事者",
            }];
       }
       //ページ移動
       this.currentPage = this.registPage.InputCOclinicInfo;
   },
   coClinicChk: function(){
       if(this.checkCoClinicInput()){
           //ページ移動
           this.currentPage = this.registPage.InputCOuserInfo;
       }
   },
   checkCoClinicInput: function(){
       //COユーザー施設登録内容のチェック
       var ret = true;
       var checkFields = [];
       checkFields.push(document.getElementById("coMedicalInstitutionName"));
       checkFields.push(document.getElementById("coDepartmentName"));
       checkFields.push(document.getElementById("coPostcode"));
       checkFields.push(document.getElementById("coPrefecture"));
       checkFields.push(document.getElementById("coCity"));
       checkFields.push(document.getElementById("coAddress"));
       checkFields.push(document.getElementById("coPhoneNumber"));
       var result = this.selfMadeValidation(checkFields)
       var errMsg = result.msg
       if(errMsg != ""){
           this.showErrorMessage(errMsg);
           ret = false;
       }
       return ret;
   },
   coUserChk: function(){
       if(this.checkCoUserInput()){
           //ページ移動
           this.currentPage = this.registPage.ComfirmCOInfo;
       }
   },
   checkCoUserInput: function(){
       //COユーザー登録内容のチェック
       var ret = true;
       var elements = document.getElementsByClassName("coUserChk");
       var result = this.selfMadeValidation(elements)
       let isOperable = false;
       for(var i=0; i < this.coUserList.length; i++){
           var user = this.coUserList[i]
           isOperable = isOperable | user.prescriptionSettings;
           if(!user.userIDFirstChoice || !user.userIDSecondChoice || !user.userIDThirdChoice){
               continue
           }
           var userID1Element = document.getElementById(i+'userId1');
           var userID2Element = document.getElementById(i+'userId2');
           var userID3Element = document.getElementById(i+'userId3');
           var ErrFlag = false
           if(user.userIDFirstChoice.toUpperCase() == user.userIDSecondChoice.toUpperCase()){
               // 第一希望と第二希望
               result.msg = result.msg + (i+1)+"番目の希望ユーザーIDが重複しています。\n"
               ErrFlag = true
               userID1Element.style["border-color"] = "red";
               userID2Element.style["border-color"] = "red";
           }
           if(user.userIDFirstChoice.toUpperCase() == user.userIDThirdChoice.toUpperCase()){
               // 第一希望と第三希望
               if(!ErrFlag){
                   result.msg = result.msg + (i+1)+"番目の希望ユーザーIDが重複しています。\n"
                   ErrFlag = true
               }
               userID1Element.style["border-color"] = "red";
               userID3Element.style["border-color"] = "red";
           }
           if(user.userIDSecondChoice.toUpperCase() == user.userIDThirdChoice.toUpperCase()){
               // 第二希望と第三希望
               if(!ErrFlag){
                   result.msg = result.msg + (i+1)+"番目の希望ユーザーIDが重複しています。\n"
                   ErrFlag = true
               }
               userID2Element.style["border-color"] = "red";
               userID3Element.style["border-color"] = "red";
           }
       }
       var errMsg = result.msg
       if(!isOperable){
        errMsg += "少なくとも1ユーザーは操作可を指定してください。\n";
       }
       if(errMsg != ""){
           this.showErrorMessage(errMsg);
           ret = false;
       }
       return ret;
   },
   uncheckPDashboard: function(notUse) {
       // CO：今は利用しないを選択時
       if (notUse) {
        this.usePDashboard = false;
        this.isPDashboardDisabled = true;
       } else {
        this.isPDashboardDisabled = false;
       }
   },
   addCoUser: function(){
     this.coUserList.push({
       familyName:"",
       firstName:"",
       prescriptionSettings: true,  //Phase2ケアオケ issue#25
       userIDFirstChoice:"",
       userIDSecondChoice:"",
       userIDThirdChoice:"",
       mail: "",
       careExporter: false,  //Phase2ケアオケ issue#20
       userClassification:"医療従事者",
     });
   },
   deleteCoUser: function(index) {
     this.coUserList.splice(index, 1);
   },
   coRegist:function(){
       this.isActive = false;
       var institutionApplication = {
            hospitalName: this.data.coMedicalInstitutionName,
            division: this.data.coDepartmentName,
            office: this.data.branchOfficeCode,
            zip: this.data.coPostcode,
            prefecture: this.data.coPrefecture,
            city: this.data.coCity,
            address1: this.data.coAddress,
            address2: this.data.coBuilding ? this.data.coBuilding : "",
            phoneNumber: this.data.coPhoneNumber,
            clientAuthentication: this.data.clientAuth,
            crossReference: true,
            biko: this.data.coBiko,
       };
       this.$store.dispatch("requestCo", {
           token: this.token,
           belongsId: this.belongsId,
           extUserId: this.extUserId,
           institutionApplication: JSON.parse(JSON.stringify(institutionApplication)),
           userInfoList: JSON.parse(JSON.stringify(this.coUserList)),
       }).then(result => {
           if(result != null && result.status === 200 ) {
               this.currentPage = this.registPage.FinishRegist;
           } else if (result != null && (result.status === 400 || result.status === 401 || result.status === 500)){
                var message = "予期しないエラーが発生しました。"
                if(result.response.body){
                    message = result.response.body.message
                } else if(result.message){
                    message = result.message
                }
                this.showErrorMessage(message)
           } else {
               this.showErrorMessage("予期しないエラーが発生しました。")
           }
           this.isActive = true;
       }).catch(error => {
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。")
            this.isActive = true;
        });
   },
   doRegistrationConfirm: function() {
        // 患者ダッシュボードを利用している場合
        if (this.usePDashboard) {
            this.$dialog.confirm({
                title: "　",
                message: pDashboardServiceName + "はケア　オーケストレーターとのデータ連携が必要なため利用するサービスから除外します。<br>よろしいでしょうか？",
                cancelText: "キャンセル",
                onConfirm: async () => {
                    await this.$store.dispatch("cancelUsePDashboard", {
                        userId: this.extUserId
                    }).then(result => {
                        if (result != null && result.status == 200) {
                            // 申込み完了ページに遷移する
                            this.currentPage = this.registPage.FinishRegist;
                        } else {
                            this.showErrorMessage("予期しないエラーが発生しました。")
                        }
                    });
                }
            });
        } else {
            this.currentPage = this.registPage.FinishRegist;
        }
    },
   download: function(){
       this.$store.dispatch("downloadConsentStatement", {
           type: consentStatement.care_orchestrator,
           uid: 0
       }).then(result => {
           if(!result.status || result.status != 200){
               if(result.obj){
                   this.showErrorMessage(result.obj.message);
               } else {
                   this.showErrorMessage(result.message);
               }
           }
       }).catch(error => {
           this.showErrorMessage(error);
       });
   },
    /**
     * QA476 郵便番号からフォーカスが外れたら桁数に応じて桁数判定フラグを設定する
     * @param zipCode 郵便番号
     * @param flagName 桁数判定フラグ
     */
    onZipBlur(zipCode, flagName) {
        this[flagName] = zipCode.length < 7;
    },
    /**
     * QA476 引数に指定した項目の末尾にフォーカスを移動する
     * @param refName フォーカスをあてる項目定義
     */
    focusMove(refName) {
        this.$nextTick(() => {
            const element = this.$refs[refName];
            if (element) {
                element.focus();
                const length = element.value.length;
                element.setSelectionRange(length, length);
            }
        })
    }
  },
  mounted: function(){
    //backgroundの変更
    document.documentElement.style.background = "rgb(0, 114, 218)";
    //keyの検証
    try {
        this.$store.dispatch("verifyKey", {
            key: this.query
        }).then(result => {
            console.log(result);
            if(result != null && result.status === 200 ) {
                this.data.mail = result.body.mail;
                this.data.publicMail = result.body.mail;
                this.data.coMailAddress = result.body.mail;
                this.getBrunchList();
                //this.currentPage = this.registPage.Login;
                this.auth();
            } else {
                this.currentPage = this.registPage.QueryError;
            }
        }).catch(error => {
            this.currentPage = this.registPage.QueryError;
        });
    } catch(err){
        this.currentPage = this.registPage.QueryError;
    }
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "data.postcode"(newValue) {
        this.invalidPostcode = isNaN(Number(newValue));
        // QA476 郵便番号自動検索処理
        if (!this.invalidPostcode && newValue.length === 7) {
            this.postCodeSearch();
        }
    },
    "data.phoneNumber"(newValue) {
      this.invalidPhoneNumber = isNaN(Number(newValue));
    },
    "data.coPostcode"(newValue) {
      this.invalidCareOrchestratorPostcode = isNaN(Number(newValue));
    },
    "data.coPhoneNumber"(newValue) {
      this.invalidCareOrchestratorPhoneNumber = isNaN(Number(newValue));
    },
  },
};
</script>
<style lang="scss" scoped>
.base {
    padding-bottom: 50px;
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.regist-area{
    width: 600px;
}
.auth-area {
    width: 300px;
}
.regist-area,
.auth-area {
    margin : 0 auto;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
.agreement-area {
    margin : 0 auto;
    width:1000px;
    height:400px;
}
.card-content table th,
.card-content table td,
.cstmHeaderCheckBox:hover,
.cstmCheckBox:hover
{
    color: whitesmoke !important;
}
.regist-area > input,
.auth-area > input{
    margin-bottom:10px;
}
.authFaild{
    margin-top:5px;
    color:tomato;
}
.require::after{
    color:tomato;
}
.opbutton {
    margin-top:10px;
    width: 100px;
}
.checkAddressButton {
    margin-top:10px;
    width: 200px;
}
.innerButton{
  margin-top:10px;
}
.nameInput {
  width: 176px !important;
}
.passInput {
  width: 250px !important;
}
.passButton {
  margin-left:5px;
  width:100px !important;
  height:29px !important;
}
.block > .b-radio {
  color: whitesmoke;
}
.confirmCoButton {
  width:350px !important;
  margin-top:10px !important;
  margin-bottom:10px !important;
}
.coNameInput {
  width: 165px !important;
}
.under_line {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/regist/RegistForm2.vue